import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col, Button} from 'reactstrap';

const SubscriberItemComponent = (props) => {
  const {account, showCurrentPackage, setActiveAccount, activeAccount, index} = props;

  const handleSetActiveAccount = () => {
    setActiveAccount(account);
  };
  return (
    <Container className='subscriber-item p-0' role={index != undefined ? 'button' : null}>
      <div className='customer-info' key={index} tabIndex={index} onClick={handleSetActiveAccount}>
        <div className='customer-info-content'>
          <div className={`${activeAccount === account ? 'active' : ''} info`}>
            {index != null && (
              <div>
                <Image src={activeAccount === account ? require('./images/radio-fill.svg') : require('./images/radio-empty.svg')} />
              </div>
            )}
            <div className='info-details'>
              <div className='subscriber-item-number bold'>{account.subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2')}</div>
              <div className='go-to-current-plan' onClick={() => showCurrentPackage(account.subscriberNo)}>
                <span>לצפיה בחבילה הקיימת</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SubscriberItemComponent;
